const normalizePlatform = (platform?: string) =>
  platform
    ?.trim()
    .toLowerCase()
    .replace(/[\/]/g, '') // remove slashes
    .replace(/\s+/g, '-') // spaces → dash
    .replace(/-+/g, '-') // collapse multiple dashes
    .replace(/^-|-$/g, ''); // trim leading/trailing dash

const buildId = (platform: string, suffix: string) =>
  `social-${normalizePlatform(platform)}-${suffix}`;

export const SocialLinksTestIDs = {
  header: 'social-links-modal-header',

  instruction: {
    container: 'social-links-instruction-container',
    heading: 'social-media-heading',
    headingText: 'social-media-header-text',
    instructions: 'social-media-instructions-text',
    instructionsText: 'social-media-instructions-content-text',
  },

  field: {
    row: (platform: string) => buildId(platform, 'field-row'),
    label: (platform: string) => buildId(platform, 'label'),
    inputRow: (platform: string) => buildId(platform, 'input-row'),
    baseUrl: (platform: string) => buildId(platform, 'base-url'),
    baseUrlText: (platform: string) => buildId(platform, 'base-url-text'),
    input: (platform: string) => buildId(platform, 'input'),
    error: (platform: string) => buildId(platform, 'error'),
  },

  errorBanner: {
    container: 'social-links-error-banner',
  },

  footer: {
    cancel: 'cancel-social-links-button',
    save: 'save-social-links-button',
  },
} as const;

export default SocialLinksTestIDs;
